// src/components/operationCenter/widgets/token/valuation/TwEfficiencyPanelWidget.tsx
// EfficiencyPanelCard uses useValuationMetrics which needs both fundamentals + price.
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import EfficiencyPanelCard from "@/components/tokenPage/valuation/EfficiencyPanelCard";

const TwEfficiencyPanelWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals", "price"]}>
        <EfficiencyPanelCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwEfficiencyPanelWidget;
